module.exports = "/api/cdn/public/static-assets/images/a91774102901ebdd195f412dd79ac53c.png";